import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';
import { Grid, Button, Dropdown, Input, Form, TextArea } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import Customerdropdown from './customerdropdown';

const styles = theme => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing.unit,
  },
});

class Order extends React.Component {
  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'md',
    discount: 0,
  };

  componentDidMount() {
    this.getMachine();
  }

  componentDidUpdate(props) {
    if (props.customer != this.props.customer) {
      this.getMachine();
    }
  }

  getMachine = () => {
    let context = this;
    this.setState({ load: true, message: 'getting machine!!!' })
    $.ajax({
      type: 'POST',
      url: Server()+'machineinfo/get.php',
      success: function(data)
      {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ data: data })
          context.setMachine(data);
        } catch (e) {

        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  setMachine = (data) => {
    let context = this;
    var x = [];
    data.map((y) => {
      let text = y.id+'->'+y.name;
      x.push({key: text, text: text, value: y.id});
    });
    try {
      context.setState({
        machineOption: x,
      });
    } catch (e) {

    }
    console.log(x);
    this.props.machineDetails(data, x);
  }

  machine = (f, { value }) => {
    let data = this.state.data;
    let gst, mrp, dnp;
    data.map((x) => {
      if (x.id == value) {
        dnp = x.dnp;
        let taxable = (x.mrp * x.gst)/100;
        mrp = Number(x.mrp) + Number(taxable);
        gst = x.gst;
      }
    });
    this.setState({ dnp: dnp, mrp: mrp, gst: gst, machine: value })
  }

  handleClickOpen = () => {
    if (this.props.type == 'edit') {
      let machine, discountper, mrp, gst, date, customerId, remarks, followup_date;
      let data = this.props.data;
      data.map((x) => {
        if (this.props.id == x.id) {
          machine = x.machine_id;
          discountper = x.discount_per;
          customerId = x.customer_id;
          mrp = x.mrp;
          gst = x.tax;
          date = x.expected_delivary;
          followup_date = x.followup_date;
          remarks = x.remarks;
        }
      });
      this.setState({ followup: followup_date, remarks: remarks, machine: machine, discount: discountper, mrp: mrp, gst: gst, expdelivery: date, customer: customerId, open: true })
    }
    else {
      this.setState({ open: true });
    }
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleMaxWidthChange = event => {
    this.setState({ maxWidth: event.target.value });
  };

  handleFullWidthChange = event => {
    this.setState({ fullWidth: event.target.checked });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  submit = () => {
    let context = this;
    let customer = this.state.customer;
    let machine = this.state.machine;
    let discountper = this.state.discount;
    let mrp = this.state.mrp;
    let gst = this.state.gst;
    let remarks = this.state.remarks;
    discountper = Number(discountper);
    mrp = Number(mrp);
    let discountAmount = ((mrp * discountper)/100).toFixed(2);
    let totalAmount = (mrp - (mrp * discountper)/100).toFixed(2);
    let date = this.state.expdelivery;
    let followup = this.state.followup;
    if (followup == '' || followup == null || followup == undefined) {
      alert('Enter the Followup Date!!!');
      return;
    }
    if (date == '' || date == null || date == undefined) {
      alert('Enter the Delivary Date!!!');
      return;
    }
    if (remarks == '' || remarks == null || remarks == undefined) {
      alert('Enter the remarks!!!');
      return;
    }
    let data1 = { 'followup': followup, 'customer': customer, 'machine': machine, 'discountper': discountper, 'mrp': mrp, 'gst': gst,
                  'discountAmount': discountAmount, 'totalAmount': totalAmount, 'date': date, 'remarks': remarks };
    let url = Server() + 'machinesales/insert.php';

    if (this.props.type == 'edit') {
      data1 = { 'followup': followup, 'customer': customer, 'machine': machine, 'discountper': discountper, 'mrp': mrp, 'gst': gst, 'remarks': remarks,
                    'discountAmount': discountAmount, 'totalAmount': totalAmount, 'date': date, 'id': this.props.id };
      url = Server() + 'machinesales/update.php';
    }
    this.setState({ load: true, message: 'Adding Details' });
    $.ajax({
      type: 'POST',
      data: data1,
      url: url,
      success: function(data)
      {
        console.log(data);
        context.setState({ load: false })
        if (data == 1) {
          context.setState({ open: false, name: '', gstin: '', mrp: '', dnp: '', machine: '', customer: '' });
          context.props.getorder(1);
        }
      },
      error: function(e)
      {
        console.log(e);
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  handleChangedate = name => event => {
    this.setState({
      expdelivery: event.target.value,
    });
  }

  handleChangedate1 = name => event => {
    this.setState({
      followup: event.target.value,
    });
  }

  update = (value, data) => {
    let caddress, cstate, cgstin;
    data.map((x) => {
      if (x.id == value) {
        caddress = x.address;
        cstate = x.state;
        cgstin = x.GSTIN;
      }
    })
    this.setState({ customer: value, customeraddress: caddress, customerstate: cstate, customergstn: cgstin})
  }

  changes = (type) => (f, { value }) => {
    this.setState({ [type]: value });
  }

  render() {
    const { classes } = this.props;
    let discountper = this.state.discount;
    let mrp = this.state.mrp;
    discountper = Number(discountper);
    mrp = Number(mrp);
    let discountAmount = ((mrp * discountper)/100).toFixed(2);
    let totalAmount = (mrp - (mrp * discountper)/100).toFixed(2);
    return (
      <React.Fragment>
        <Loading load={this.state.load} message={this.state.message} />
        { (this.props.type == 'edit') ?
          (
            <div style={{cursor: 'pointer'}} onClick={this.handleClickOpen}>Edit</div>
          ) :
          (
            <Button primary onClick={this.handleClickOpen} style={{display: this.props.machinesalesedit}}>
              Machine Order
            </Button>
          )
        }
        <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={this.handleClose} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Machine Order</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <Customerdropdown update={this.update} customer={this.state.customer} />
                <div style={{display: 'flex'}}>
                <div>State: {this.state.customerstate}</div>
                <div style={{marginLeft: '5%'}}>GSTIN: {this.state.customergstn}</div>
                </div>
              </Grid.Column>
              { this.state.customer ?
                (
                  <Grid.Column mobile={16} tablet={16} computer={6}>
                    Select Machine<br/>
                    <Dropdown placeholder='Machine' style={{ borderColor: '#5A9CBB' }}
                     fluid search selection onChange={this.machine} fluid
                     options={this.state.machineOption} value={this.state.machine} />
                  </Grid.Column>
                ) :
                (
                  <div></div>
                )
              }
              { this.state.mrp ?
                (
                  <Grid.Column mobile={16} tablet={16} computer={10}>
                    <Grid>
                      <Grid.Column mobile={16} tablet={16} computer={4}>
                        Discount(%)<br/>
                        <Input value={this.state.discount} fluid type="number" onChange={this.handleChange('discount')} />
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={5}>
                        Excepted Delivary<br/>
                        <input type="date" id="date" value={this.state.expdelivery}
                          style={{width: '100%', height: 35 }} onChange={this.handleChangedate('date')} />
                      </Grid.Column>
                      <Grid.Column mobile={16} tablet={16} computer={5}>
                        Followup Date<br/>
                        <input type="date" id="date" value={this.state.followup}
                          style={{width: '100%', height: 35 }} onChange={this.handleChangedate1('followup')} />
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                ) :
                (
                  <div></div>
                )
              }
            </Grid>
            <br/>
            { this.state.mrp ?
              (
                <div>
                  <table id="table" width="100%">
                    <tr>
                      <th id="tableheader" style={{width: '10%'}}><center>GST</center></th>
                      <th id="tableheader" style={{width: '30%'}}><center>MRP</center></th>
                      <th id="tableheader" style={{width: '30%'}}><center>Discount(Rs.)</center></th>
                      <th id="tableheader" style={{width: '30%'}}><center>Total</center></th>
                    </tr>
                    <tr>
                      <td><center>{this.state.gst+'%'}</center></td>
                      <td><center>{'Rs. '+this.state.mrp}</center></td>
                      <td><center>{'Rs. '+discountAmount}</center></td>
                      <td><center>{'Rs. '+totalAmount}</center></td>
                    </tr>
                  </table>
                  <br/>
                  <Form>
                    <TextArea placeholder='Remark...' onChange={this.changes('remarks')}
                     value={this.state.remarks}/>
                  </Form>
                </div>
              ):
              (
                <div></div>
              )
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={this.submit} color="primary">
              Submit
            </Button>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

Order.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Order);
